import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import ExpensesSection from "../ExpensesSection";
import "./Modal.css";

// Standalone host for the guide's expense tracker — mirrors PollsModal's
// shape exactly (ExpensesSection is guide-level only, no per-place/event
// embedding to also support here).
class ExpensesModal extends Component {
  render() {
    return (
      <div className="modal">
        <Modal {...this.props} size="md" aria-labelledby="contained-modal-title-vcenter" centered scrollable={true}>
          <Modal.Header>
            <div style={{ width: "100%" }}>
              <div className="dialog-heading">
                <div>
                  <h4 style={{ color: "#3598DB" }}>Expenses</h4>
                </div>
                <div>
                  <FontAwesomeIcon
                    icon={solid("times")}
                    className="pointer color-blue"
                    onClick={() => this.props.onHide()}
                  ></FontAwesomeIcon>
                </div>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <ExpensesSection />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default ExpensesModal;
